import { SEO } from "@/components/SEO"
import { Separator } from "@/components/ui/separator"

export function PrivacyPage() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        url="/privacy"
        description="Privacy Policy for Prediction Mining Game. Learn how we handle data, blockchain information, and third-party services."
        keywords="privacy policy, data protection, blockchain privacy, GDPR"
        noindex={true}
      />
      <div className="container py-16 max-w-3xl">
      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-muted-foreground mb-8">Last updated: January 2025</p>

      <div className="prose prose-neutral dark:prose-invert max-w-none">
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. Information We Collect</h2>
          <p className="text-muted-foreground mb-4">
            WELEPHANT is a decentralized application. We do not collect personal information
            beyond what is publicly available on the blockchain. Your wallet address and
            transaction history are public by nature of blockchain technology.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. Blockchain Data</h2>
          <p className="text-muted-foreground mb-4">
            All transactions on WELEPHANT are recorded on the BNB Chain blockchain.
            This data is public and immutable. We do not have control over blockchain data.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Cookies and Analytics</h2>
          <p className="text-muted-foreground mb-4">
            We use cookies and analytics tools to improve the user experience.
            These tools collect anonymized usage data such as page views and
            interaction patterns.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Third-Party Services</h2>
          <p className="text-muted-foreground mb-4">
            We integrate with third-party services including wallet providers and
            decentralized protocols. Please review their respective privacy policies
            for information on how they handle your data.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">5. Chat Data</h2>
          <p className="text-muted-foreground mb-4">
            In-game chat is powered by Push Protocol, a decentralized messaging service.
            Chat messages are stored on IPFS, not on our servers. We do not have the
            ability to delete or modify chat messages. Please refer to Push Protocol's
            privacy policy for details.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">6. Data Security</h2>
          <p className="text-muted-foreground mb-4">
            Your private keys and wallet credentials are never transmitted to or stored
            by WELEPHANT. You are responsible for securing your own wallet.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">7. Children's Privacy</h2>
          <p className="text-muted-foreground mb-4">
            WELEPHANT is not intended for users under 18 years of age. We do not
            knowingly collect information from minors.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">8. User Rights</h2>
          <p className="text-muted-foreground mb-4">
            As a decentralized application, we do not maintain personal data beyond
            what is publicly recorded on the blockchain or through third-party
            decentralized services. We are unable to delete blockchain transactions
            or messages stored on decentralized protocols.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">9. Policy Changes</h2>
          <p className="text-muted-foreground mb-4">
            We may update this privacy policy from time to time. Continued use of the
            service after changes constitutes acceptance of the updated policy.
          </p>
        </section>

        <Separator className="my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">10. Contact</h2>
          <p className="text-muted-foreground mb-4">
            For privacy-related inquiries, contact us at contact@welephant.xyz.
          </p>
        </section>
      </div>
    </div>
    </>
  )
}
